import React, { useState, useEffect, useRef, useContext } from "react";
import AppContext from "../../../context/Context";
import { Dropdown, DropdownButton } from 'react-bootstrap';
import split_1_1 from '../../../assets/img/split/1-1.png'; 
import split_1_1_d from '../../../assets/img/split/1-1-d.png'; 

import split_2_1 from '../../../assets/img/split/2-1.png'; 
import split_2_1_d from '../../../assets/img/split/2-1-d.png'; 

 

import split_3_2 from '../../../assets/img/split/3-2.png'; 
import split_3_2_d from '../../../assets/img/split/3-2-d.png'; 

 


const MultiChartDropdown = ({shapeClick, splitScreen}) => {
 

  const {
    config: { isDark },
  } = useContext(AppContext);
  

  return (

   <div className="ms-2">
    <DropdownButton  
      title={ <img src={splitScreen === 1 ? !isDark ? split_1_1 : split_1_1_d : splitScreen === 2 ? !isDark ? split_2_1: split_2_1_d : splitScreen === 3 ? !isDark ? split_3_2: split_3_2_d : ''} />} 
      id="dropdown-basic-button" 
      variant='falcon-default'
      className="custom-drop-down"
      disabled={window.innerWidth < 768}
     >
   
      <Dropdown.Item >
        
        <div className="shapeType">
          <div className="shape_inner" onClick={()=>shapeClick(1)}>
                <img src={!isDark ? split_1_1 : split_1_1_d} className={splitScreen == 1  ? "active-screen":""}/>
            </div>
            <div className="shape_inner" onClick={()=>shapeClick(2)}>
               <img src={!isDark ? split_2_1: split_2_1_d} className={splitScreen == 2  ? "active-screen":""}/>
            </div>
            <div className="shape_inner" onClick={()=>shapeClick(3)}>
              <img src={!isDark ? split_3_2: split_3_2_d}  className={splitScreen == 3  ? "active-screen":""}/>
              </div>
            
        </div>
      </Dropdown.Item>
   
    </DropdownButton>
   </div>
     
    
  );
};

export default MultiChartDropdown;
